var Haiku = require("@haiku/core");
var _code_deco2_code = require("./../deco2/code.js");
var _code_deco1_code = require("./../deco1/code.js");
var _code_deco3_code = require("./../deco3/code.js");
module.exports = {
  metadata: {
    uuid: "90324d73-5838-4221-982d-f6a287687ffa",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon5",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon5",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/c61d20c8-ce40-4e8f-bd0f-e94515091f3c/db69e5d94bb80ce142942055905bfcbf5c16445a/",
    core: "4.5.1",
    title: "Circle",
    type: "haiku",
    relpath: "code/circle/code.js"
  },
  options: {},
  states: { PlayIt: { type: "string", value: "stop", edited: true } },
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:f49aeee6c443": {
        x1: "18.0667488%",
        y1: "10.6250737%",
        x2: "81.6432506%",
        y2: "87.5059097%"
      },
      "haiku:Circle-2188d689141ec7f9": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 84.978,
        "sizeAbsolute.y": 85.681,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:79e0c60b4f7e": {
        "translation.x": 43.94,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "style.margin": "0",
        "translation.y": 41.717,
        "sizeMode.z": 1,
        "origin.x": 0.392,
        "origin.y": 3.282,
        "style.zIndex": 3,
        playback: {
          "0": {
            value: Haiku.inject(function(PlayIt) {
              return PlayIt;
            }, "PlayIt"),
            edited: true
          }
        },
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "2000": { value: 6.284, edited: true }
        }
      },
      "haiku:a9a5f1f7f705": {
        "translation.x": 43.69,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "style.margin": "0",
        "translation.y": 40.922,
        "sizeMode.z": 1,
        "origin.x": 3.175,
        "origin.y": 0.517,
        "style.zIndex": 2,
        playback: {
          "0": {
            value: Haiku.inject(function(PlayIt) {
              return PlayIt;
            }, "PlayIt"),
            edited: true
          }
        },
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "2000": { value: -6.284, edited: true }
        }
      },
      "haiku:a005059a590b": {
        "sizeAbsolute.y": 62,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 62,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 43.979499999999994,
        "translation.y": 41.31,
        "style.zIndex": 1,
        "rotation.z": {
          "0": { curve: "linear", edited: true, value: 0 },
          "2000": { edited: true, value: 6.284 }
        }
      },
      "haiku:2ea71bd19a5e": {
        "translation.x": 44.368,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "style.margin": "0",
        "translation.y": 41.483,
        "sizeMode.z": 1,
        "origin.x": 0.064,
        "origin.y": -1.632,
        "style.zIndex": 4,
        playback: {
          "0": {
            value: Haiku.inject(function(PlayIt) {
              return PlayIt;
            }, "PlayIt"),
            edited: true
          }
        },
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "2000": { value: -6.284, edited: true }
        }
      },
      "haiku:c187a10b1e4a": { stopColor: "#A3CE32", offset: "0%" },
      "haiku:a8b64a7ccac4": { stopColor: "#FFAC39", offset: "100%" },
      "haiku:6a8e824dc00e": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd",
        strokeDasharray: "3,4",
        strokeLinecap: "round"
      },
      "haiku:d19fdc82d683": {
        stroke: "url(#25b5284f55b7)",
        "translation.x": -3
      },
      "haiku:ab659eb8ef69": {
        d:
          "M34.3,60.8 C50.8685425,60.8 64.3,47.3685425 64.3,30.8 C64.3,14.2314575 50.8685425,0.8 34.3,0.8 C17.7314575,0.8 4.3,14.2314575 4.3,30.8 C4.3,47.3685425 17.7314575,60.8 34.3,60.8 Z"
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Circle-2188d689141ec7f9",
      "haiku-title": "Circle"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "a005059a590b",
          "haiku-title": "Oval",
          "haiku-source":
            "designs/AnimatorWebsiteIcon5.sketch.contents/slices/Oval.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "9130094daad0" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "f49aeee6c443",
                  "haiku-title": "linearGradient-1-2db749",
                  id: "25b5284f55b7"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "c187a10b1e4a" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "a8b64a7ccac4" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: {
              "haiku-id": "6a8e824dc00e",
              "haiku-title": "Page-1",
              id: "2c4e89bad6fa"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "d19fdc82d683",
                  "haiku-title": "Docs-icon",
                  id: "05078864af3a"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "ab659eb8ef69",
                      "haiku-title": "Oval",
                      id: "647ed0d1906f"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: _code_deco2_code,
        attributes: {
          "haiku-id": "a9a5f1f7f705",
          "haiku-var": "_code_deco2_code",
          "haiku-title": "Deco2",
          "haiku-source": "./code/deco2/code.js"
        },
        children: []
      },
      {
        elementName: _code_deco1_code,
        attributes: {
          "haiku-id": "79e0c60b4f7e",
          "haiku-var": "_code_deco1_code",
          "haiku-title": "Deco1",
          "haiku-source": "./code/deco1/code.js"
        },
        children: []
      },
      {
        elementName: _code_deco3_code,
        attributes: {
          "haiku-id": "2ea71bd19a5e",
          "haiku-var": "_code_deco3_code",
          "haiku-title": "Deco3",
          "haiku-source": "./code/deco3/code.js"
        },
        children: []
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon5/code/circle/code.js
// module id = 447
// module chunks = 127651196306611